/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_User_Email_ExistsInputs */



/**
* | output |
* | --- |
* | "A member with this email already exists" |
*
* @param {Err_User_Email_ExistsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_user_email_exists = /** @type {((inputs?: Err_User_Email_ExistsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_User_Email_ExistsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Un membre avec cet email existe déjà")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ya existe un miembro con este correo electrónico")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Já existe um membro com este e-mail")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esiste già un membro con questa email")
	return /** @type {LocalizedString} */ ("A member with this email already exists")
});